import React from 'react';
import './MissionSection.scss';

const MissionSection = () => {
  return (
    <section className="mission-section">
      <div className="container">
        <div className="mission-content">
          <p className="mission-text">
            <span className="mission-bold">Driving impact through sustainable energy solutions,</span>
            <br />
            <span className="mission-light">we aim to empower communities and reduce carbon footprints.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;



